import styled from 'styled-components'

export const StyledSuccessFeedbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-height: calc(100% - 2rem);
  padding: 1rem;

  img {
    margin-bottom: 1rem;
    max-width: 300px;
    filter: grayscale(1);
  }
`

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  button {
    margin-top: 2rem;
  }
`
